import { format } from "date-fns";
import { variaveisDisponiveis } from "./constantes";

export function prepararFiltrosComIntervalo(contexto, filtros, pessoaIds) {
  const filtrosProcessados = { ...filtros };
  const porIntervalo = [];

  if (filtros.dataVencimentoStart && filtros.dataVencimentoEnd) {
    porIntervalo.push({
      coluna: "dataVencimento",
      de: filtros.dataVencimentoStart,
      ate: filtros.dataVencimentoEnd,
    });
  }

  delete filtrosProcessados.dataVencimentoStart;
  delete filtrosProcessados.dataVencimentoEnd;
  filtrosProcessados.porIntervalo = porIntervalo;
  const chavePessoa = obterChavePessoaPorContexto(contexto);
  if (chavePessoa && pessoaIds?.length) {
    filtrosProcessados[chavePessoa] = pessoaIds;
  }
  return filtrosProcessados;
}

function obterChavePessoaPorContexto(contexto) {
  const mapChave = {
    "condicional-cobranca": "pessoaClienteId",
    "condicional-lembrete": "pessoaClienteId",
    "conta-receber-cobranca": "pagadorId",
    "conta-receber-lembrete": "pagadorId",
  };

  return mapChave[contexto];
}

export function prepararCorpoRequisicao(contexto, anexo, pessoasSelecionadas) {
  const body = { contexto };
  if (anexo) {
    body.anexo = anexo;
  }
  if (pessoasSelecionadas?.length) {
    body.pessoaIds = pessoasSelecionadas;
  }
  return body;
}

export function previewMensagem(
  mensagem,
  valores = {
    apelidoFantasia: "Minha Empresa",
    nomeCompletoCliente: "João Silva",
    primeiroNomeCliente: "João",
    documentosAVencer: [{ valor: 100, dataVencimento: new Date() }],
    dataAgendamento: format(new Date(), "dd/MM/yyyy"),
    horaAgendamento: format(new Date(), "HH:mm"),
    nomeUsuario: "Maria",
  },
) {
  let preview = mensagem;

  const documentosFormatados = valores.documentosAVencer
    .map((doc) => {
      const data = new Date(doc.dataVencimento).toLocaleDateString("pt-BR");
      const valor = Number(doc.valor).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return `🔸 Vencimento: ${data} - Valor: ${valor}`;
    })
    .join("\n");

  preview = preview.replace(/\{documentosAVencer\}/g, documentosFormatados);

  variaveisDisponiveis.forEach((variavel) => {
    if (variavel === "documentosAVencer") return;

    preview = preview.replace(
      new RegExp(`\\{${variavel}\\}`, "g"),
      valores[variavel] || `{${variavel}}`,
    );
  });

  return preview
    .replace(/\*([^*]+?(?:\*[^*]+)*)\*/g, "<strong>$1</strong>")
    .replace(/_([^_]+?(?:_[^_]+)*)_/g, "<em>$1</em>");
}
